/**
 * Created by wxb on 2023/07/21.
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Carousel } from "antd";
class index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {

    }
    render() {
        const picContentStyle = {
            height: '394px',
            color: '#fff',
            lineHeight: '394px',
            textAlign: 'center',
        };
        return (
            <>
                <div style={{ display: "flex", justifyContent: "center", padding: "0 260px", width: 1920 }}>
                    <div style={{ marginTop: 152 }}>
                        <div style={{ display: "flex", justifyContent: "center", height: 394 }}>
                            <div className="zgh-aboutUs-company-introduce-pic">
                                <Carousel autoplay className="zgh-company-introduce-carousel">
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic1"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic2"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic3"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic4"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic5"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic6"></div>
                                    </div>
                                    <div>
                                        <div style={picContentStyle} className="zgh-company-introduce-aboutUs-pic7"></div>
                                    </div>
                                </Carousel>
                            </div>
                            <div className="zgh-aboutUs-company-introduce-text">
                                <div className="zgh-company-introduce-detailsTab-title">智共荟智能科技</div>
                                <div className="zgh-company-introduce-detailsTab-describe">智共荟智能科技成立于2018年，公司位于中国上海。是一家专注于流程型工业，致力于推动全真互联数据工厂的高科技企业。通过数据化技术和元宇宙技术，建立数字孪生产品体系、生产标准体系、知识平台体系、生产判定体系、生产预测体系和一贯制体系，实现预测性生产和预测性管理的数据工厂。</div>
                            </div>
                        </div>
                        <div className="zgh-aboutUs-company-introduce-corporateCulture">
                            <p className="zgh-menu-title" style={{ paddingBottom: 48 }}>企业文化</p>
                            <div className="zgh-aboutUs-company-introduce-corporateCultureItem">
                                <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol">
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemColIcon1"></div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-title">企业使命</div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-describe">成为工业数据化的引领者</div>
                                </div>
                                <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol">
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemColIcon2"></div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-title">核心价值观</div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-describe">融合工业智慧，共享数据价值，
                                        荟萃团队创新</div>
                                </div>
                                <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol">
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemColIcon3"></div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-title">经营理念</div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-describe">赢得客户忠诚度</div>
                                </div>
                                <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol">
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemColIcon4"></div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-title">企业精神</div>
                                    <div className="zgh-aboutUs-company-introduce-corporateCultureItemCol-describe">革故鼎新，知行合一</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ width: 1920 }}>
                    <p className="zgh-menu-title">服务客户</p>
                    <div style={{ padding: "48px 260px 88px 260px" }}>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img1"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img2"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img3"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img4"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img5"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img6"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img7"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img8"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img9"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img10"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img11"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img12"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img13"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img14"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img15"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img16"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img17"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img18"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img19"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img20"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="zgh-company-developmentHistory" id="companyDevelopmentHistory">
                        <div className="zgh-company-developmentHistory-title">公司发展历程</div>
                        <div style={{ position: "relative", height: 598, width: 1920, margin: "0 auto" }}>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 59, left: 269 }}>
                                <div className="zgh-company-developmentHistory-card-pic1"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2018年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">公司成立于上海</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 27, left: 516 }}>
                                <div className="zgh-company-developmentHistory-card-pic2"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2019年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">ISA产线数据应用系统开始预研</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 92, left: 838 }}>
                                <div className="zgh-company-developmentHistory-card-pic3"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2020年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">公司获上海第一批认定高新科技企业</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 104, left: 1151 }}>
                                <div className="zgh-company-developmentHistory-card-pic4"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2021年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">ISA系统成功上线广受好评</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 243, left: 1460 }}>
                                <div className="zgh-company-developmentHistory-card-pic5"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2022年</div>
                                    <div className="zgh-company-developmentHistory-card-describe" style={{ marginBottom: 8 }}>ISA全真互联数据工厂研发成功</div>
                                    <div className="zgh-company-developmentHistory-card-describe" style={{ marginBottom: 8 }}>上海市元宇宙场景第一名</div>
                                    <div className="zgh-company-developmentHistory-card-describe">上海市专精特新</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default withRouter(index)
